import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import EnrollmentForm from './Form'

export default function EnrollmentFormIndex() {
  const { id } = useParams()
  const list = useSelector(state => state.mentorship.mentorship.list)
  const item = id === 'new' ? null : list?.find(m => String(m.id) === id)
  return <EnrollmentForm item={item} />
}
